// src/feed/updateFeedItemVisibility.ts
//
// Change the visibility tier on a feed_item. Only the owner can
// call this (rules enforce). Cloud Function fans out the change:
// when an item goes from 'private' → 'public', new audiences need
// the item materialized into their /feed; when it goes from
// 'public' → 'private', existing audiences need it removed.

import { doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { db } from '../services/firebase';
import { FeedVisibility } from './types';

export async function updateFeedItemVisibility(
  itemId: string,
  visibility: FeedVisibility
): Promise<boolean> {
  try {
    await updateDoc(doc(db, 'feed_items', itemId), {
      visibility,
      updated_at: serverTimestamp(),
    });
    return true;
  } catch (err) {
    console.warn('updateFeedItemVisibility failed:', err);
    return false;
  }
}
